<template>
  <ul class="treeview">
    <li v-for="(level1, index1) of taxonomy" :key="'taxonomy-' + index1" >
      <span v-b-toggle="'taxonomy-' + index1">
        <b-icon icon="tag-fill" class="text-primary mr-2"></b-icon>
        {{level1.value}}
        <b-badge
          class="ml-2"
          :variant="level1.children.length ? 'success' : 'warning'"
          pill
        >{{level1.children.length}}</b-badge>
      </span>
      <b-collapse :id="'taxonomy-' + index1">
        <ul v-if="level1.children.length">
          <li v-for="(level2, index2) of level1.children" :key="'taxonomy-' + index1 + '-' + index2" class="position-relative">
            <span v-b-toggle="'taxonomy-' + index1 + '-' + index2">
              <b-icon icon="tag-fill" class="text-primary mr-2"></b-icon>
              {{level2.value}}
              <b-badge
                class="ml-2"
                :variant="level2.children.length ? 'success' : 'warning'"
                pill
              >{{level2.children.length}}</b-badge>
            </span>
            <b-collapse :id="'taxonomy-' + index1 + '-' + index2">
              <ul v-if="level2.children.length">
                <li v-for="(level3, index3) of level2.children" :key="'taxonomy-' + index1 + '-' + index2 + '-' + index3">
                  <span v-b-toggle="'taxonomy-' + index1 + '-' + index2 + '-' + index3">
                    <b-icon icon="tag-fill" class="text-primary mr-2"></b-icon>
                    {{level3.value}}
                    <b-badge
                     v-if="level3.children"
                      class="ml-2"
                      :variant="level3.children.length ? 'success' : 'warning'"
                      pill
                    >{{level3.children.length}}</b-badge>
                  </span>
                  <b-collapse :id="'taxonomy-' + index1 + '-' + index2 + '-' + index3" v-if="level3.children">
                    <ul v-if="level3.children.length">
                      <li v-for="(level4, index4) of level3.children" :key="'taxonomy-' + index1 + '-' + index2 + '-' + index3 + '-' + index4">
                        <b-icon icon="tag-fill" class="text-primary mr-2"></b-icon>
                        {{level4.value}}
                      </li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>
      </b-collapse>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    taxonomy: Array
  },
}
</script>

<style lang="scss">
.treeview {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    margin: 5px 0;
  }
  ul {
    position: relative !important;
    list-style: none;
    padding-left: 30px;
    
    &:before {
      content: "";
      position: absolute;
      width: 1px;
      height: calc(100% - 13px);
      background-color: rgba(0,0,0,.25);
      left: 8px;
    }
    li {
      position: relative;
      margin: 5px 0;
      &:before {
        content: "";
        position: absolute;
        width: 15px;
        height: 1px;
        background-color: rgba(0,0,0,.25);
        top: 10px;
        left: -21px;
      }
      &:last-child {
        &:after {
          content: "";
          position: absolute;
          left: -30px;
          top: 11px;
          height: calc(100% - 11px);
          width: 20px;
          background-color: white;
        }
      }
    }
  }
}
</style>